import { BatteryChargingIcon } from './BatteryChargingIcon';

/**
 * author: Google
 * id F365ACF3-9453-4516-B592-AECD72AB7433
 * name battery-charging
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-charging.svg
 * tags
 * - Battery 
 * - Home Automation 
 * - Automotive 
 */
export const BatteryChargingFullIcon = BatteryChargingIcon;
export default BatteryChargingFullIcon